<template>
	<div class="container pt-6 pb-10">
		<div class="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-2 py-2 mb-4">
			<div class="flex flex-row items-center gap-4">
				<v-btn color="grey darken-1" class="uppercase" dark to="/oferte">
					<v-icon>mdi-chevron-left</v-icon>
					Inapoi
				</v-btn>
				<h1 class="page-title-secondary">Oferta vanzari nr. {{ oferta.id }}</h1>
			</div>
			<div v-if="!loadingOferta" class="flex flex-row flex-wrap items-center gap-2 lg:justify-end">
				<Facturi :proformaDate="proforma.data" :clientEmail="oferta.email" :ofertaGrandTotal="grand_total"
					:statusUpfrontInvoice="oferta.status_factura_avans" @sendAccountingEmail="emailFactAvans"
					@generateProforma="generateProforma" @updateProforma="updateFacturaProforma"
					@downloadProforma="saveProforma" @emailProforma="sendProforma" />
				<!-- <ToComanda /> -->
				<v-dialog v-model="visibleComandaModal" max-width="600px">
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="blue darken-1" class="uppercase" dark v-bind="attrs" v-on="on"
							@click="loadMateriale()">
							<v-icon>mdi-arrow-right-bottom</v-icon>
							Comanda
						</v-btn>
					</template>
					<v-card class="p-6">
						<ComandaNoua v-if="matDepozit" :matDepozit="matDepozit" @comandaNoua="addComanda"
							@closeComandaModal="visibleComandaModal = false" @furnizorUnic="furnizorUnic">
						</ComandaNoua>
					</v-card>
				</v-dialog>
				<DocPDF :oferta="oferta" :sending-email="sendingEmail" @download="downloadOfertaPDF"
					@sendEmail="emailOfertaPDF" />
				<v-btn color="teal" dark class="uppercase" :to="'/oferte/edit/' + oferta.id">
					<v-icon>mdi-pencil</v-icon>
					Editeaza
				</v-btn>
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon v-bind="attrs" v-on="on">
							<v-icon>mdi-dots-vertical</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item link @click="openDuplicateModale">
							<v-icon class="mr-1">mdi-content-duplicate</v-icon>
							Duplica oferta
						</v-list-item>
						<v-list-item link @click="visibleDeleteModal = true">
							<v-icon class="mr-1">mdi-delete-forever-outline</v-icon>
							Sterge oferta
						</v-list-item>
					</v-list>
				</v-menu>
			</div>
		</div>
		<v-progress-linear v-if="loadingOferta" indeterminate color="teal darken-1" class="mb-4"></v-progress-linear>
		<div v-else class="flex flex-col gap-6">
			<v-card class="doc-header flex flex-col lg:flex-row lg:justify-between gap-6 lg:gap-10 px-6 py-6">
				<div>
					<v-label class="text-sm font-medium uppercase block pb-2">Detalii client</v-label>
					<div class="text-lg">
						<p class="font-semibold text-black mb-0">{{ oferta.nume }}</p>
						<v-list color="transparent" dense>
							<v-list-item v-if="oferta.cui || oferta.reg_com">{{ oferta.cui }} | {{ oferta.reg_com
							}}</v-list-item>
							<v-list-item v-if="oferta.adresa">{{ oferta.adresa }}<span v-if="oferta.oras">, {{
								oferta.oras }}
								</span></v-list-item>
						</v-list>
						<v-list color="transparent" dense>
							<v-list-item v-if="oferta.persoana">Reprezentant: <span class="font-semibold mx-1">{{
								oferta.persoana }}</span></v-list-item>
							<v-list-item v-if="oferta.tel">{{ oferta.tel }}</v-list-item>
							<v-list-item v-if="oferta.email">{{ oferta.email }}</v-list-item>
							<v-list-item v-if="oferta.cc_obj">
								<span v-for="item, idx in oferta.cc_obj">{{ item }}
									<span v-if="idx != oferta.cc_obj.length - 1">, </span>
								</span>
							</v-list-item>
							<v-btn color="teal" class="my-1" text @click="visibleEmailCCModal = true">Adauga email
								CC</v-btn>
						</v-list>
					</div>
				</div>
				<div>
					<v-label class="text-sm font-medium uppercase block pb-2">Detalii oferta</v-label>
					<div class="text-lg">
						<v-list color="transparent" dense>
							<v-list-item>Data oferta:<span class="font-semibold mx-1">{{ oferta.data | formatDate
									}}</span></v-list-item>
							<v-list-item>Intocmit de: <span class="font-semibold mx-1">{{ oferta.username
									}}</span></v-list-item>
						</v-list>
						<v-chip :color="getStatusColor(oferta.status_oferta)" small dark>
							{{ oferta.status_oferta }}
						</v-chip>
					</div>
				</div>
			</v-card>

			<v-card>
				<v-card-title>Produse</v-card-title>
				<v-card-text>
					<div class="overflow-x-auto">
						<table class="responsive-table text-base">
						<thead>
							<tr>
								<th class="center-align">Nr.</th>
								<th>Denumire produs</th>
								<th class="center-align">Termen livrare</th>
								<th class="center-align">Cantitate</th>
								<th class="right-align">Pret unitar</th>
								<th class="right-align">Greutate</th>
								<th class="right-align">Pret / kg</th>
								<th class="right-align">Valoare fara TVA</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(produs, index) in oferta.produse_obj" :key="produs.nr">
								<td class="center-align">{{ index + 1 }}</td>
								<td class="width40" :class="produs.modified ? 'red-text' : ''">
									<span v-if="produs.denumire.value">{{
										produs.denumire.value
									}}</span>
									<span v-else>{{ produs.denumire }}</span>
									<span> {{ produs.material }}</span>
									<!--
                    -->
									<span v-if="produs.detalii">{{ " - " + produs.detalii }}</span>
									<!--
                    -->
									<span v-if="produs.dimL">, <span>{{ dimensiune_text(produs) }}</span></span>
									<!--
                    -->
									<span>{{ ", aliaj: " + produs.aliaj }}</span>
								</td>
								<td class="center-align">{{ produs.t_livrare | NoData }}</td>
								<td class="center-align">
									{{ produs.cantitate + " " + produs.um }}
								</td>
								<td class="right-align">{{ produs.pret_u }} {{ oferta.moneda }}</td>
								<td class="right-align">{{ produs.greutate | NoData }} kg</td>
								<td class="right-align">
									{{ produs.pret_kg | NoData }} {{ oferta.moneda }}
								</td>
								<td class="right-align">{{ produs.pret_t }} {{ oferta.moneda }}</td>
							</tr>
							<tr v-for="produs in oferta.custom_obj">
								<td class="center-align">{{ produs.nr }}</td>
								<td class="width40">
									<span>{{ produs.denumire }}</span>
									<!--
                    -->
									<span v-if="produs.detalii">{{ " - " + produs.detalii }}</span>
									<!--
                    -->
									<span v-if="produs.dimensiune_text">{{
										" - " + produs.dimensiune_text
									}}</span>
									<!--
                    -->
								</td>
								<td class="center-align">{{ produs.t_livrare | NoData }}</td>
								<td class="center-align">
									{{ produs.cantitate + " " + produs.um }}
								</td>
								<td class="right-align">{{ produs.pret_u }} {{ oferta.moneda }}</td>
								<td class="right-align">-</td>
								<td class="right-align">-</td>
								<td class="right-align">{{ produs.pret_t }} {{ oferta.moneda }}</td>
							</tr>
							<tr v-if="oferta.debitare_obj != null && oferta.debitare_obj.form">
								<td v-if="oferta.produse_obj" class="center-align">
									{{ products_no_oferta + 1 }}
								</td>
								<td class="bold">{{ oferta.debitare_obj.name }}</td>
								<td class="center-align">-</td>
								<td class="center-align">
									{{ oferta.debitare_obj.cantitate + " " + oferta.debitare_obj.um }}
								</td>
								<td class="right-align">
									{{ oferta.debitare_obj.pret }} {{ oferta.moneda }}
								</td>
								<td class="right-align">-</td>
								<td class="right-align">-</td>
								<td class="right-align">
									{{ oferta.debitare_obj.val }} {{ oferta.moneda }}
								</td>
							</tr>
							<tr v-if="oferta.transport_obj != null && oferta.transport_obj.form">
								<td v-if="oferta.produse_obj" class="center-align">
									{{
										oferta.debitare_obj.form == true
											? products_no_oferta + 2
											: products_no_oferta + 1
									}}
								</td>
								<td class="bold">{{ oferta.transport_obj.name }}</td>
								<td class="center-align">-</td>
								<td class="center-align">
									{{
										oferta.transport_obj.cantitate + " " + oferta.transport_obj.um
									}}
								</td>
								<td class="right-align">
									{{ oferta.transport_obj.pret }} {{ oferta.moneda }}
								</td>
								<td class="right-align">-</td>
								<td class="right-align">-</td>
								<td class="right-align">
									{{ oferta.transport_obj.val }} {{ oferta.moneda }}
								</td>
							</tr>
							<tr v-else-if="oferta.transport_obj != null && oferta.transport_obj.included">
								<td v-if="oferta.produse_obj" class="center-align">
									{{
										oferta.debitare_obj.form == true
											? products_no_oferta + 2
											: products_no_oferta + 1
									}}
								</td>
								<td class="bold">Transport inclus</td>
							</tr>
							<tr v-else>
								<td v-if="oferta.produse_obj" class="center-align">
									{{
										oferta.debitare_obj.form == true
											? products_no_oferta + 2
											: products_no_oferta + 1
									}}
								</td>
								<td class="bold">Nu include transport</td>
							</tr>
						</tbody>
						<tr></tr>
						<tfoot>
							<tr class="table-totals">
								<td colspan="6"></td>
								<td class="right-align bold">Total fara TVA</td>
								<td class="right-align bold">
									{{ oferta.val_fara_tva }} {{ oferta.moneda }}
								</td>
							</tr>
							<tr>
								<td colspan="6"></td>
								<td class="right-align">TVA</td>
								<td class="right-align">
									{{ oferta.val_tva }} {{ oferta.moneda }}
								</td>
							</tr>
							<tr>
								<td colspan="6"></td>
								<td class="right-align bold">TOTAL</td>
								<td class="right-align bold">
									{{ oferta.suma }} {{ oferta.moneda }}
								</td>
							</tr>
						</tfoot>
					</table>
					</div>
				</v-card-text>
			</v-card>
			<v-card class="mb-10">
				<v-card-title>Detalii suplimentare</v-card-title>
				<v-card-text class="text-base">
					<div v-if="oferta.obs" class="flex flex-row justify-start items-start gap-1">
						<div class="mb-1">Observatii:</div>
						<p class="text-base font-semibold">{{ oferta.obs }}</p>
					</div>
					<div class="flex flex-row flex-wrap justify-between items-center gap-x-6 gap-y-2">
						<div>Conditii livrare: <span class="font-semibold mx-1">{{ oferta.t_livrare | NoData }}</span>
						</div>
						<div>Conditii plata: <span class="font-semibold mx-1">{{ oferta.t_plata | NoData }}</span></div>
						<div>Valabilitate oferta: <span class="font-semibold mx-1">{{
							daysTxt || NoData
						}}</span>
						</div>
					</div>
				</v-card-text>
			</v-card>
		</div>

		<!-- MODALS -->

		<v-dialog v-model="visibleEmailCCModal" max-width="400px">
			<v-card>
				<v-form ref="emailCCForm" v-model="validEmailCCForm" @submit.prevent="addCC">
					<v-card-title>
						Adauga adresa email in CC
					</v-card-title>
					<v-card-text>
						<v-text-field label="Email" text outlined dense :rules="[rules.required, rules.email]"
							v-model="ccmail"></v-text-field>
					</v-card-text>
					<div class="flex flex-row justify-end gap-2 p-4">
						<v-btn color="blue-grey" class="uppercase" dark large
							@click="visibleEmailCCModal = false">Anuleaza</v-btn>
						<v-btn color="teal" dark class="uppercase" large type="submit">Adauga email</v-btn>
					</div>
				</v-form>
			</v-card>
		</v-dialog>

		<v-dialog v-model="visibleDuplicateModal" max-width="400px">
			<v-card>
				<v-card-title>
					Poti genera o noua oferta, bazata pe cea existenta
				</v-card-title>
				<v-card-text>
					<label for="client_id">Alege clientul</label>
					<model-select id="client_id" :options="clienti" v-model="newClient"
						placeholder="Nume client"></model-select>
					<br />
					<div class="input-field">
						<input id="data" type="date" class="validate" v-model="today" />
						<label for="data">Data</label>
					</div>
				</v-card-text>
				<div class="flex flex-row justify-end gap-2 mt-4 p-4">
					<v-btn color="blue-grey" class="uppercase" dark large
						@click="visibleDuplicateModal = false">Anuleaza</v-btn>
					<v-btn color="teal" dark class="uppercase" large
						@click="duplicateOferta(oferta.id)">Genereaza</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<v-dialog v-model="visibleDeleteModal" max-width="400px">
			<v-card>
				<v-card-title>
					Sterge definitiv oferta nr. {{ oferta.id }}?
				</v-card-title>
				<div class="flex flex-row justify-end gap-2 mt-4 p-4">
					<v-btn color="blue-grey" class="uppercase" dark large
						@click="visibleDeleteModal = false">Anuleaza</v-btn>
					<v-btn color="red darken-1" dark class="uppercase" large
						@click="deleteOferta(oferta.id)">Sterge</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<!-- OLD MODALS -->

		<!-- Modal Whasapp -->
		<!-- <div id="modal_whatsapp" class="modal modal-whatsapp modal-small">
			<div class="modal-content">
				<h6 class="text-xl mb-4">Trimite oferta PDF pe Whasapp</h6>
				<p v-if="oferta.tel">Tel client: {{ oferta.tel }}</p>
				<p v-else class="text-red-400">
					Clientul nu are numar de telefon
				</p>
				<div class="btn-group flex justify-start mt-4">
					<button v-if="oferta.tel" href="#!" class="btn modal-close green" v-on:click="sendWhatsapp()">
						<i class="material-icons left">whatsapp</i>Trimite PDF
					</button>
					<a href="#!" class="modal-action modal-close btn blue-grey">Inchide</a>
				</div>
			</div>
		</div> -->


		<div class="row container">
			<div class="col s6" style="overflow: hidden;">
				<!-- <pre>{{ user }}</pre> -->
				<!-- <pre>{{proforma}}</pre> -->
				<!-- <pre>{{ oferta }}</pre> -->
				<!-- <pre>File: {{file}}</pre> -->
				<!-- <pre>Image Url: {{imgUrl}}</pre> -->
			</div>
			<div class="col s6">
				<!-- <pre>{{oferta.cc_obj}}</pre> -->
				<!-- <pre>Pdf: {{pdfFile}}</pre> -->
				<!-- <pre>Image: {{image}}</pre> -->
			</div>
		</div>
	</div>
</template>

<script>
import Facturi from "./Facturi.vue";
import DocPDF from "./DocPDF.vue";
// import ToComanda from "./ToComanda.vue";
import { ModelSelect } from "vue-search-select";
import ComandaNoua from "@/components/Oferte/ComandaNoua";
// import images from "../../assets/oferta_images.js";
import moment from "moment";
// import jsPDF from "jspdf";
// import fonts from "../../assets/fonts/fonts.js";
import { pdf_oferta_materie_prima } from "@/documents/oferta/pdf_oferta_materie_prima.js";
import { pdf_proforma_materie_prima } from "@/documents/proforma/pdf_proforma_materie_prima.js";
import { daysText } from '@/utils';
// import { carport_ad } from "@/pdf_functions/addon_func/carport_aluminiu.js";
// import { mag_pubele_ad } from "@/pdf_functions/addon_func/magazii_pubele.js";

export default {
	name: "detaliioferta",
	data() {
		return {
			validEmailCCForm: false,
			visibleComandaModal: false,
			visibleEmailCCModal: false,
			visibleDuplicateModal: false,
			visibleDeleteModal: false,
			sendingEmail: false,
			today: moment().format("YYYY-MM-DD"),
			docType: "Oferta",
			tipFactura: "avans",
			visibleFactAvans: false,
			factAvans: null,
			factAvansMsg: "",
			observatii: "avans 100%",
			procent_proforma: "100",
			ccmail: null,
			ccfields: [],
			bccfields: [],
			matDepozit: [],
			client: {},
			newClient: {
				value: "",
				text: "",
			},
			file: "",
			imgUrl: "",
			pdfFile: "",
			image: "",
			pdfExtraInfo: false,
			rules: {
				required: value => !!value || 'Câmp obligatoriu',
				email: value => !value || /.+@.+\..+/.test(value) || "Adresa email invalida",
			}
		};
	},
	components: {
		Facturi,
		DocPDF,
		// ToComanda,
		ModelSelect,
		ComandaNoua,
	},
	computed: {
		loadingOferta() {
			return this.$store.getters.loadingOferta
		},
		user() {
			return this.$store.getters.loggedUser;
		},
		oferta() {
			return this.$store.getters.oferta;
		},
		oferta_id() {
			return this.oferta.id;
		},
		proforma() {
			return this.$store.getters.proforma;
		},
		clienti() {
			return this.$store.getters.selectClienti;
		},
		curs() {
			return this.$store.getters.curs;
		},
		pdfName() {
			return `${this.docType} nr. ${this.oferta.id} ${this.oferta.nume}`;
		},
		proformaName() {
			return `${this.docType} nr. ${this.proforma.id_proforma} ${this.oferta.nume}`;
		},
		daysTxt() {
			return daysText(this.oferta.valid)
		},
		grand_total() {
			let total = this.oferta.suma;
			if (this.oferta.moneda == "eur") {
				total = (total * this.curs).toFixed(2);
			}
			return total;
		},

		products_no_oferta() {
			return this.oferta.produse_obj.length + this.oferta.custom_obj.length;
		},
		products_no_proforma() {
			return this.proforma.produse_obj.length + this.proforma.custom_obj.length;
		},
		statusColor() {
			if (this.oferta.status_oferta == 'noua') return 'bg-red-400'
			else if (this.oferta.status_oferta == 'contactat') return 'bg-yellow-400'
			else if (this.oferta.status_oferta == 'acceptata') return 'bg-green-400'
			else if (this.oferta.status_oferta == 'nu e acceptata') return 'bg-gray-400'
		}
	},
	watch: {
		oferta_id(value) {
			this.$store.dispatch("fetchProforma", value);
		},
		tipFactura(value) {
			if (value == "finala") {
				this.observatii = "100%";
			} else if (value == "avans") {
				this.factAvans = null;
				this.observatii = "avans 100%";
			}
		},
		factAvans(value) {
			if (value == "true") {
				this.factAvansMsg = "Este factura de avans";
			} else if (value == "false") {
				this.factAvansMsg = "NU este factura de avans";
			} else {
				this.factAvansMsg = "";
			}
		},
	},
	methods: {
		getStatusColor(status) {
			if (status == 'noua') return 'red lighten-1'
			else if (status == 'contactat') return 'orange darken-1'
			else if (status == 'acceptata') return 'green darken-1'
			else if (status == 'nu e acceptata') return 'grey darken-1'
		},
		replaceSpecialCh(str) {
			if (str) {
				return str
					.replace(/ș|Ș/g, "s")
					.replace(/ț|Ț/g, "t")
					.replace(/î|Î/g, "i")
					.replace(/ă|â|Â|Ă/g, "a")
			} else {
				return ""
			}
		},
		formatPhoneNo(str) {
			if (str) {

				if (str.charAt(0) == "+" || str.charAt(0) == "(") {
					return str;
				} else {
					return "+4" + str;
				}
			} else {
				return "-"
			}
		},
		openDuplicateModale() {
			this.fetchClienti()
			this.visibleDuplicateModal = true
		},
		generateProforma(percent) {
			this.procent_proforma = percent
			this.generateFacturaProforma()
		},
		clientInfo() {
			let cui = this.oferta.cui ? "CUI: " + this.oferta.cui + "<br>" : "";
			let reg_com = this.oferta.reg_com
				? "Reg.Com. " + this.oferta.reg_com + "<br>"
				: "";
			let adresa = this.oferta.adresa
				? "Adresa: " + this.oferta.adresa + "<br>"
				: "";
			let oras = this.oferta.oras ? "Oras: " + this.oferta.oras : "";
			return cui + reg_com + adresa + oras;
		},
		async addCC() {
			const validEmailCCForm = await this.$refs.emailCCForm.validate();
			if (validEmailCCForm) {
				this.$store.dispatch("addCCMail", {
					id_client: this.oferta.id_client,
					mail: this.ccmail,
				});
				this.visibleEmailCCModal = false
				this.ccmail = null;
			}
		},
		// isModified(produs) {
		//   let mod = false;
		//   if (produs.dim_text && produs.dim_text != produs.dim_str) {
		//     mod = true;
		//   }
		//   produs.modified = mod;
		// },
		dimensiune_text(produs) {
			let str = "";
			if (produs.denumire.value == "Profil U") {
				str = produs.dimH;
			} else {
				str = produs.dimL;
			}
			if (produs.denumire.value == "Profil U") {
				str += " x " + produs.dimL;
			}
			if (produs.dimH) {
				str += " x " + produs.dimH;
			}
			if (produs.dimG) {
				str += " x " + produs.dimG;
			}
			if (str == null || str == "") {
				return "";
			} else {
				if (!produs.dimH && !produs.dimG) {
					str = "D " + str;
				}
				return str + " mm";
			}
		},
		loadMateriale() {
			let materiale = [];
			this.oferta.produse_obj.forEach((produs) => {
				let denumire_produs = `${produs.denumire.value} ${produs.material
					} ${this.dimensiune_text(produs)}, aliaj: ${produs.aliaj}`;
				let material = {
					denumire: denumire_produs,
					cantitate: produs.cantitate + " " + produs.um,
					furnizor: "",
				};
				materiale.push(material);
			});
			this.matDepozit = materiale;
			this.client = {
				nume: this.oferta.nume,
				adresa:
					this.replaceSpecialCh(this.oferta.adresa) +
					(this.oferta.oras
						? `, ${this.replaceSpecialCh(this.oferta.oras)}`
						: ""),
				persoana: this.oferta.persoana,
				tel: this.oferta.tel,
			};
		},
		fetchClienti() {
			this.$store.dispatch("fetchClienti");
		},
		duplicateOferta(id) {
			if (this.newClient.value == "") {
				alert("Alege clientul!");
			} else {
				let newOferta = {
					oferta_id: id,
					client_id: this.newClient.value,
					data: this.today,
					user_id: this.user.id_user,
				};
				this.$store.dispatch("duplicateOferta", newOferta);
				// console.log('duplicate offer', newOferta)
			}
		},
		changeDocType(type) {
			if (this.docType != type) {
				this.docType = type;
			}
		},
		generateFacturaProforma() {
			let newProforma = {
				client_id: this.oferta.id_client,
				oferta_id: this.oferta.id,
				oferta_data: this.oferta.data,
				user_id: this.oferta.id_user,
				data: this.today,
				moneda: this.oferta.moneda,
				curs: this.curs,
				procent_proforma: this.procent_proforma,
				suma: this.oferta.suma,
				val_fara_tva: this.oferta.val_fara_tva,
				val_tva: this.oferta.val_tva,
				valid: this.oferta.valid,
				t_livrare: this.oferta.t_livrare,
				produse_obj: JSON.stringify(this.oferta.produse_obj),
				custom_obj: JSON.stringify(this.oferta.custom_obj),
				debitare_obj: JSON.stringify(this.oferta.debitare_obj),
				transport_obj: JSON.stringify(this.oferta.transport_obj),
			};
			this.$store.dispatch("addProforma", newProforma);
		},
		updateFacturaProforma() {
			let updProforma = {
				proforma_id: this.proforma.id_proforma,
				oferta_id: this.oferta.id,
				data: this.today,
				moneda: this.oferta.moneda,
				curs: this.curs,
				procent_proforma: this.procent_proforma,
				suma: this.oferta.suma,
				val_fara_tva: this.oferta.val_fara_tva,
				val_tva: this.oferta.val_tva,
				valid: this.oferta.valid,
				t_livrare: this.oferta.t_livrare,
				produse_obj: JSON.stringify(this.oferta.produse_obj),
				custom_obj: JSON.stringify(this.oferta.custom_obj),
				debitare_obj: JSON.stringify(this.oferta.debitare_obj),
				transport_obj: JSON.stringify(this.oferta.transport_obj),
			};
			this.$store.dispatch("updProforma", updProforma);
		},

		// handleFileUpload() {
		//   this.image = this.$refs.file.files[0];
		// },
		// sendFile() {
		//   const formData = new FormData();
		//   formData.append("file", this.image);

		//   this.$http
		//     .post(
		//       "https://hub.cuprolli.ro/app_back/index.php/api/proforma/uploadfile",
		//       formData,
		//       {
		//         headers: {
		//           "Content-Type": "multipart/form-data"
		//         }
		//       }
		//     )
		//     .then(function(response) {
		//       console.log(response);
		//     })
		//     .catch(function(error) {
		//       console.error(error);
		//     });
		// },
		async saveProforma() {
			console.log('new print')
			this.changeDocType("Proforma");
			const doc = await pdf_proforma_materie_prima.createProformaMateriePrimaPDF(this.proforma);
			let pdfName = `Proforma nr. ${this.proforma.id_proforma} ${this.proforma.nume}`;
			doc.save(pdfName + ".pdf");
		},
		async sendProforma() {
			this.changeDocType("Proforma");
			// const doc = this.createProformaPDF();
			const doc = await pdf_proforma_materie_prima.createProformaMateriePrimaPDF(this.proforma);
			const pdf = btoa(doc.output());
			const payload = {
				data: pdf,
				id_oferta: this.proforma.id_proforma,
				doctype: this.docType,
				client_mail: this.proforma.email,
				cc_arr: JSON.stringify(this.oferta.cc_obj),
				sender: this.user.email_user,
				bcc_arr: JSON.stringify(this.bccfields),
			};
			// Send doc to php script for emailing forward
			// this.$http
			// 	.post(
			// 		process.env.VUE_APP_HUB_API_HOST + "email/vanzari/oferta",
			// 		payload,
			// 		{
			// 			headers: { x_api_key: process.env.VUE_APP_HUB_API_KEY },
			// 		}
			// 	)
			// 	.then(function (response) {
			// 		console.log(response.body);
			// 		M.toast({ html: response.body, classes: "blue" });
			// 	})
			// 	.catch(function (error) {
			// 		console.log(error.body);
			// 		M.toast({
			// 			html: "Eroare! Proforma nu a fost trimisa",
			// 			classes: "red darken-1",
			// 		});
			// 	});
			console.log('send proforma', payload)
		},
		async downloadOfertaPDF() {
			this.changeDocType("Oferta");
			const doc = await pdf_oferta_materie_prima.createOfertaMateriePrimaPDF(this.oferta, this.pdfExtraInfo);
			// const doc = this.createOfertaPDF();
			doc.save(this.pdfName + ".pdf");
		},
		sendWhatsapp() {
			this.changeDocType("Oferta");
			console.log("sendWhatsapp");
		},
		async emailOfertaPDF() {
			this.changeDocType("Oferta");
			this.sendingEmail = true
			const doc = await pdf_oferta_materie_prima.createOfertaMateriePrimaPDF(this.oferta, this.pdfExtraInfo);
			// const doc = this.createOfertaPDF();
			const pdf = btoa(doc.output());
			const payload = {
				data: pdf,
				id_oferta: this.oferta.id,
				doctype: this.docType,
				client_mail: this.oferta.email,
				cc_arr: JSON.stringify(this.oferta.cc_obj),
				sender: this.user.email_user,
				sender_phone: this.user.tel_user,
				bcc_arr: JSON.stringify(this.bccfields),
			};
			// Send doc to php script for emailing forward
			this.$http
				.post(
					process.env.VUE_APP_HUB_API_HOST + "email/vanzari/oferta",
					payload,
					{
						headers: { x_api_key: process.env.VUE_APP_HUB_API_KEY },
					}
				)
				.then(function (response) {
					console.log(response.body);
					M.toast({ html: response.body, classes: "blue" });
					this.sendingEmail = false
				})
				.catch(function (error) {
					console.log(error.body);
					this.sendingEmail = false
					M.toast({
						html: "Eroare! Oferta nu a fost trimisa",
						classes: "red darken-1",
					});
				});
		},
		async emailFactAvans(newInvoice) {
			this.pdfExtraInfo = true;
			const doc = await pdf_oferta_materie_prima.createOfertaMateriePrimaPDF(this.oferta, this.pdfExtraInfo);
			// const doc = this.createOfertaPDF();
			const pdf = btoa(doc.output());
			this.pdfExtraInfo = false;
			// Send doc to php script for emailing forward
			let obj = {
				data: pdf,
				id_oferta: this.oferta.id,
				client: this.oferta.nume,
				tip_factura: newInvoice.typeInvoice,
				obs: newInvoice.obs,
			};
			if (newInvoice.invoiceMsg != "") {
				obj.avans_msg = newInvoice.invoiceMsg;
			}
			this.$http
				.post(
					process.env.VUE_APP_HUB_API_HOST + "email/vanzari/factura_avans",
					obj,
					{
						headers: { x_api_key: process.env.VUE_APP_HUB_API_KEY },
					}
				)
				.then(function (response) {
					this.oferta.status_factura_avans = moment()
						.format()
						.slice(0, 19)
						.replace("T", " ");
					let ultimulStatus = {
						ultimul_status: this.oferta.status_factura_avans,
						id: this.oferta.id,
					};
					this.$store.dispatch("updOfertaStatusFactAvans", ultimulStatus);

					M.toast({ html: response.body, classes: "blue" });
				})
				.catch(function (error) {
					console.log(error.body);
					M.toast({
						html: "Eroare! Oferta nu a fost trimisa",
						classes: "red darken-1",
					});
				});

		},
		fetchOferta(id) {
			this.$store.dispatch("fetchOferta", id);
		},
		deleteOferta(id) {
			this.$store.dispatch("deleteOferta", id);
			this.visibleDeleteModal = false
		},
		furnizorUnic(value) {
			this.matDepozit.forEach(function (produs) {
				produs.furnizor = value;
			});
		},
		addComanda() {
			let products = this.oferta.produse_obj;
			products.forEach((produs, index) => {
				produs.dimensiune = produs.dim_str;
				produs.status_livrare = "in asteptare";
				produs.furnizor = this.matDepozit[index].furnizor;
			});
			let customProd = this.oferta.custom_obj;
			customProd.forEach((produs) => {
				produs.status_livrare = "in asteptare";
			});
			let newComanda = {
				client_id: this.oferta.id_client,
				oferta_id: this.oferta.id,
				data: this.today,
				firma: this.oferta.firma,
				stare: "activa",
				moneda: this.oferta.moneda,
				suma: this.oferta.suma,
				val_fara_tva: this.oferta.val_fara_tva,
				val_tva: this.oferta.val_tva,
				p_avans: null,
				suma_avans: 0,
				suma_termen: this.oferta.suma,
				t_plata: null,
				transport: null,
				obs: null,
				user_id: this.oferta.id_user,
				produse_obj: JSON.stringify(products),
				custom_obj: JSON.stringify(this.oferta.custom_obj),
				transport_obj: JSON.stringify(this.oferta.transport_obj),
			};
			// console.log('newComanda', newComanda);
			this.$store.dispatch("addComanda", newComanda);
		},
		dataStr(date) {
			return date;
		},
	},
	created: function () {
		this.fetchOferta(this.$route.params.id);
		this.$store.dispatch("fetchCurrency");
	},
	mounted: function () {
		M.Modal.init(document.querySelectorAll(".modal"));
	},
	updated: function () {
		M.Dropdown.init(document.querySelectorAll(".dropdown-trigger"), {
			constrainWidth: false,
		});
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.doc-header .v-list .v-list-item {
	min-height: fit-content;
	padding: 0;
}

.card-panel {
	padding: 15px 50px;
}

.document-header ul li {
	margin: 5px 0;
}

.ccfield input {
	display: inline-block;
	width: 50% !important;
}

li .btn-text {
	display: block;
}

hr {
	color: #d5d5d5;
}

#dropdown {
	transform: translate(0, -25px);
}

#facturi,
#pdf {
	transform: translate(0, -40px);
}

.alert-msg {
	padding: 2px 10px;
}
</style>
